// extracted by mini-css-extract-plugin
module.exports = {"wide":"ButtonGroup_wide__3BGqt","small-buttons":"ButtonGroup_small-buttons__3BIlZ"};